"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCollapsibleMotionProps = void 0;
var _react = require("react");
var _collapsible = require("@cbhq/cds-common/animation/collapsible");
var _useMotionProps = require("../motion/useMotionProps");
const useCollapsibleMotionProps = ({
  collapsed,
  direction = 'vertical',
  dangerouslyDisableOverflowHidden
}) => {
  const defaultStyle = (0, _react.useMemo)(() => {
    // override visibility: hidden
    const styles = {
      visibility: 'visible'
    };
    if (dangerouslyDisableOverflowHidden) {
      return styles;
    }
    return Object.assign({}, styles, {
      // need this for enter animation to have correct masking effect
      overflow: 'hidden'
    });
  }, [dangerouslyDisableOverflowHidden]);
  return (0, _useMotionProps.useMotionProps)({
    enterConfigs: [_collapsible.animateInOpacityConfig[direction], Object.assign({}, _collapsible.animateInMaxSizeConfig[direction], {
      toValue: 'auto'
    })],
    exitConfigs: {
      tokens: [_collapsible.animateOutOpacityConfig[direction], _collapsible.animateOutMaxSizeConfig[direction]],
      // prevent focus on collapsed element
      transitionEnd: {
        visibility: 'hidden'
      }
    },
    style: defaultStyle,
    // prevent animation on mount
    initial: false,
    animate: collapsed ? 'exit' : 'enter'
  });
};
exports.useCollapsibleMotionProps = useCollapsibleMotionProps;